import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table type-default" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "movie-search-result-row" }
const _hoisted_12 = { class: "mr8 info-area" }
const _hoisted_13 = {
  key: 0,
  class: "ib mr4 ts"
}
const _hoisted_14 = {
  key: 1,
  class: "ib mr4 ts"
}
const _hoisted_15 = { class: "ib place" }
const _hoisted_16 = { class: "ib mr4 road-name" }
const _hoisted_17 = { class: "ib mr4 direction" }
const _hoisted_18 = {
  key: 0,
  class: "ib mr4 place-name"
}
const _hoisted_19 = { class: "ib kp" }
const _hoisted_20 = { class: "btn-area" }
const _hoisted_21 = ["onClick"]

import TabPaneComponent from 'src/components/Top/TabPaneComponent.vue';
import { dtFormat } from 'src/lib/dateHelper';
import { useMovieSearchStore } from 'src/composables/useMovieSearch';

const DEFAULT_ACTIVE_TAB = 'comment';


export default /*@__PURE__*/_defineComponent({
  __name: 'MovieSearchResultPane',
  setup(__props) {

const {
  movieSearch,
  styles,
  tabs,
  isMovieSearchResultModeNone,
  isMovieSearchResultModeDetail,
  isMovieSearchResultModeArea,
  isMovieSearchResultModeRoute,
  onMovieSearchResultRowClick,
  onMovieSearchResultPlayClick,
  onTabElementClick,
} = useMovieSearchStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "table-container movie-search-result",
      style: _normalizeStyle({
    'min-height': _unref(styles).movieListStyles.minHeight,
    'max-height': _unref(styles).movieListStyles.maxHeight,
  })
    }, [
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_unref(movieSearch).isQuerying)
              ? (_openBlock(), _createElementBlock("th", _hoisted_2, " 検索中… "))
              : (_unref(isMovieSearchResultModeDetail))
                ? (_openBlock(), _createElementBlock("th", _hoisted_3, " 詳細検索結果 "))
                : (_unref(isMovieSearchResultModeArea))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_4, " 範囲検索結果 "))
                  : (_unref(isMovieSearchResultModeRoute))
                    ? (_openBlock(), _createElementBlock("th", _hoisted_5, " ルート検索結果 "))
                    : (_openBlock(), _createElementBlock("th", _hoisted_6, " 検索結果 "))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_unref(isMovieSearchResultModeNone))
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7))
            : (_unref(movieSearch).isQuerying)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("td", { class: "ta-center" }, [
                    _createElementVNode("i", { class: "fa-2x fas fa-spinner fa-spin" })
                  ], -1)
                ]))]))
              : (_unref(movieSearch).results.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("td", null, "動画が見つかりませんでした", -1)
                  ]))]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_unref(movieSearch).results, (ml) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: ml.id,
                      class: _normalizeClass({selected: ml.isSelected})
                    }, [
                      _createElementVNode("td", {
                        onClick: ($event: any) => (_unref(onMovieSearchResultRowClick)(ml))
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            (ml.searchType !== 'route')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(dtFormat)(ml.startTs, 'yyyy/mm/dd HH:MM:SS')) + "~ ", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_14, " 再生時間 " + _toDisplayString(_unref(dtFormat)(ml.endTs, 'HH:MM:SS')), 1)),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("span", _hoisted_16, _toDisplayString(ml.startKp.roadNameDispShort), 1),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(ml.startKp.direction), 1),
                              (ml.startKp.placeName !== 'main_line')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(ml.startKp.placeName), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_19, [
                                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-location-arrow" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(ml.startKp.kp.toFixed(1)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("button", {
                              class: "btn btn-primary btn-xs",
                              onClick: ($event: any) => (_unref(onMovieSearchResultPlayClick)($event, ml))
                            }, [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("i", { class: "fas fa-play" }, null, -1)
                            ]))], 8, _hoisted_21)
                          ])
                        ])
                      ], 8, _hoisted_10)
                    ], 2))
                  }), 128))
        ])
      ])
    ], 4),
    _createVNode(TabPaneComponent, {
      tabs: _unref(tabs),
      "default-active-tab": DEFAULT_ACTIVE_TAB,
      "tab-container-min-height": _unref(styles).tabStyles.containerMinHeight,
      "tab-container-max-height": _unref(styles).tabStyles.containerMaxHeight,
      "tab-content-max-height": _unref(styles).tabStyles.contentMaxHeight,
      onClick: _unref(onTabElementClick)
    }, null, 8, ["tabs", "tab-container-min-height", "tab-container-max-height", "tab-content-max-height", "onClick"])
  ], 64))
}
}

})